// extracted by css-extract-rspack-plugin
export default {"header":"header-RYYjay","avatar":"avatar-K4HUDj","avatarSquare":"avatarSquare-ZzxqRg","author":"author-jsWI5D","authorText":"authorText-dUjvKB","username":"username-JihtLy"};